import '~/stylesheets/application.css'

import { initRails } from '~/lib/rails'
import { initCookiesBar } from '~/lib/cookies'
import { initMasonry } from '~/lib/masonry'
import { initLightbox } from '~/lib/lightbox'
import { initLazyImages } from '~/lib/lazyImages'
import { initExpandableText } from '~/lib/expandableText'
import { initMobileMenu, initStickyHeader } from '~/lib/navigation'

function init(): void {
  initCookiesBar()
  initMasonry()
  initLightbox()
  initLazyImages()
  initExpandableText()
  initMobileMenu()
  initStickyHeader()
}

initRails()

document.addEventListener('DOMContentLoaded', init)
window.addEventListener('load', init)
